import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService, ExportTaskProcessor } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { format, parseISO } from 'date-fns';
import { PlantsService } from '../plants.service';
import PlantsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/plants/plants.entity';
import { LOCALIZED_PROPERTIES, PLANT_EXPORT_ID, PLANT_TITLE } from './plant.constants';
import { ShortCompanyAttributes } from '@albatrosdeveloper/ave-models-package';

@Injectable()
export class PlantExport {
  constructor(
    private exportService: ExportService,
    private plantsService: PlantsService,
  ) {}
//cambiar atributo
  private transformItem(item: PlantsAttributes) {
    return {
      name: get(item, 'name', ''),
      company: this.getList<ShortCompanyAttributes>(get(item, 'company', [])),
      status: ExportTaskProcessor.types.ave.status(get(item, 'statusId', '')),
    };
  }

  private getList<T extends { name: string }>(items: T[]): string {
    if (!Array.isArray(items) || items.length === 0) return '-';
    return items.map((division) => division.name).join(', ');
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: PLANT_EXPORT_ID,
      title: PLANT_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(PLANT_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.plantsService.findByFilter(buildQuery(
          seed(this.plantsService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(PLANT_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(PLANT_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
